
	import {
		IonContent,
		IonHeader,
		IonTitle,
		IonToolbar,
		IonButtons,
		IonButton,
		modalController,
		toastController,
		alertController,
		IonIcon,
		IonItem,
		IonLabel,
		IonToggle,
		IonInput,
		IonSelect,
		IonSelectOption
	} from "@ionic/vue";
	import { defineComponent } from "vue";
	import { calendar, personCircle, list, gitNetwork, cog, calendarOutline, statsChartOutline } from 'ionicons/icons';
	import { useI18n }        from 'vue-i18n';
	import EditAccessPage     from '@/views/access/EditAccessPage.vue';
	import TerminalPage       from '@/views/devices/TerminalPage.vue';
	import DeviceService      from '@/services/device.service';
	import CameraService      from '@/services/camera.service';
	import ZoneService        from '@/services/zone.service';
	import EventService       from '@/services/event.service';
	import AccessService      from '@/services/access.service';
	import CameraWebRTCPlayer from './CameraWebRTCPlayer.vue';
	import moment from 'moment-timezone';
	import Timezone from '@/utils/Timezone';
	let translate;
	export default defineComponent({
		name: "DeviceModal",
		components: { IonContent, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonItem, IonLabel, IonToggle, IonInput, IonSelect, IonSelectOption, CameraWebRTCPlayer },
		props: ['device'],
		data()
		{
			return {
				selectedTab:            1,
				loadingCamera:      false,
				cameraMonitorId:        0,
				cameraSecret:          '',
				cameraUrl:             '',
				type:                  '',
				name:                  '',
				brand:                 '',
				model:                 '',
				icon:                   0,
				latitude:               0,
				longitude:              0,
				port_trigger_open:     '',
				port_trigger_close:    '',
				port_keep_open:        '',
				port_signal_open:      '',
				port_signal_close:     '',
				port_signal_blocked:   '',
				port_signal_presence:  '',
				prevent_customers:  false,
				keepOpenUntil:        '0',
				hostname:              '',
				port:                  '',
				serverurl:             '',
				all_zones:             [],
				zone_id:                0,
				barrier_type:           0,
				status: '',
				state: '',
				present: '',
				elka_settings: {//THIS SHOULD BE LOADED FROM THE BARRIER ON FIRST CONNECTION TO AVOID WIPING IMPORTANT FACTORY SETTINGS
					stay_open_time:               300,//OK
					prewarning_before_closing_time: 3,//OK
					prewarning_before_opening_time: 0,//OK
					maintenance_interval:         250,//OK
					barrier_type:                   7,//OK
					barrier_speed:                  1,//OK
					radio_remote_control_code: '-+-+-+-+-',
					relay_operating_modes:         {
						0: '0',
						1: '0',
						2: '0',
						3: '12',//Default 12
						4: '5',
						5: '6',
						6: '0',
						7: '0',
						8: '0',
						9: '0',
						10: '0',
						11: '0',
						12: '0',
						13: '0',
						14: '0'
					},//OK
					loop_a_activated: 0,//OK
					loop_a_sensitivity: 4,//OK
					loop_a_holdtime: 3,//OK
					loop_a_fnc_enter: 0,//OK
					loop_a_fnc_exit: 0,//OK
					loop_a_fnc_presence: 0,//OK

					loop_b_activated: 0,//OK
					loop_b_sensitivity: 4,//OK
					loop_b_holdtime: 3,//OK
					loop_b_fnc_enter: 0,//OK
					loop_b_fnc_exit: 0,//OK
					loop_b_fnc_presence: 0,//OK

					loop_c_activated: 0,//OK
					loop_c_sensitivity: 4,//OK
					loop_c_holdtime: 3,//OK
					loop_c_fnc_enter: 0,//OK
					loop_c_fnc_exit: 0,//OK
					loop_c_fnc_presence: 0,//OK

					power_supply: 0,//OK
					opening_limitation: 0,//OK
					limitation_safety: 0,//OK

					rtapl_end_pos_closed: 1,//OK
					rtapl_before_opening: 2,//OK
					rtapl_before_closing: 2,//OK
					rtapl_during_opening: 1,//OK
					rtapl_during_closing: 1,//OK
					rtapl_during_intermediate_stop: 1,//OK
					rtapl_end_pos_open: 0,//OK

					gnapl_end_pos_closed: 0,//OK
					gnapl_before_opening: 0,//OK
					gnapl_before_closing: 0,//OK
					gnapl_during_opening: 0,//OK
					gnapl_during_closing: 0,//OK
					gnapl_during_intermediate_stop: 0,//OK
					gnapl_end_pos_open: 1,//OK

					warning_end_pos_closed: 0,//OK
					warning_before_opening: 1,//OK
					warning_before_closing: 1,//OK
					warning_during_opening: 1,//OK
					warning_during_closing: 1,//OK
					warning_during_intermediate_stop: 0,//OK
					warning_end_pos_open: 0,//OK

					bt_combi_selection: 0,//OK

					force_monitoring: 1,//OK
					photoelectric_barrier_mode: 0,//OK
					photoelectric_barrier_closing_auto: 1,//OK
					ls_test: 0,//OK
					induction_loop_safety_mode: 0,//OK
					immediate_closing: 1,//OK
					dead_mans_mode: 0,//OK
					boom_missing_function: 0,//OK
					auto_sync_function: 1,//OK

					password_protection: 3552,//3552 = DISABLED
					led_boom_lightning: 0,//0 = Switching takes place at 90°, 7 = Switching takes place at approx. 55°
					led_boom_lightning_red_yellow: 0,//0 = RED, 1 = YELLOW

					//Directional Logics (This all all 0 by default)
					dl1_input_selection: 0,//OK
					dl1_fnc_passing_from_left: 0,//OK
					dl1_fnc_passing_from_right: 0,//OK
					dl1_vehicle_counting_type_from_left: 0,//OK
					dl1_vehicle_counting_type_from_right: 0,//OK
					dl1_fnc_entering_from_left: 0,//OK
					dl1_fnc_entering_from_right: 0,//OK
					dl1_fnc_report_entering_from_left: 0,//OK
					dl1_fnc_report_entering_from_right: 0,//OK

					dl2_input_selection: 0,//OK
					dl2_fnc_passing_from_left: 0,//OK
					dl2_fnc_passing_from_right: 0,//OK
					dl2_vehicle_counting_type_from_left: 0,//OK
					dl2_vehicle_counting_type_from_right: 0,//OK
					dl2_fnc_entering_from_left: 0,//OK
					dl2_fnc_entering_from_right: 0,//OK
					dl2_fnc_report_entering_from_left: 0,//OK
					dl2_fnc_report_entering_from_right: 0,//OK
				},
				events_page: 1,
				events_rows: 0,
				events_items: [],
				events_loaded: false,
				events_fields: [
					{
						key: 'date_at',
						label: translate('date_at'),
						sortable: false
					},
					{
						key: 'name',
						label: translate('event'),
						sortable: false
					},
					{
						key: 'description',
						label: translate('description'),
						sortable: false
					},
					{
						key: 'access_card',
						label: translate('access_card'),
						sortable: false
					}
				],
			}
		},
		setup() {
			const closeModal = () => {
				console.log('CLOSE MODAL');
				modalController.dismiss();
			};
			const { t } = useI18n({
				inheritLocale: true,
				useScope: 'global'
			});
			const openAccessCard = async (accessCardId: any) => {
				const response = await AccessService.get(accessCardId);
				if (response.success) {
					const modal = await modalController.create({
						component: EditAccessPage,
						// canDismiss: false,
						cssClass: 'my-custom-class',
						componentProps: {
							access_card: response.access_card
						}
					});
					return modal.present();
				}
			};
			const openTerminal = async (device: any) => {
				const modal = await modalController.create({
					component: TerminalPage,
					cssClass: 'modal-fullscreen',
					componentProps: {
						device: device
					}
				});
				return modal.present();
			};
			translate = t;
			return { closeModal, calendar, personCircle, list, gitNetwork, cog, calendarOutline, statsChartOutline, t, openAccessCard, openTerminal };
		},
		async mounted()
		{
			if (this.device.camera_id > 0) {
				this.loadingCamera = true;
				this.loadCamera(this.device.camera_id);
			}
			await this.loadZones();
			if (this.device.id > 0 && this.can_view_events) {
				await this.loadEvents();
			}
			// for(var i = 0; i < 14; i++) {
			//     //@ts-ignore
			//     this.elka_settings.relay_operating_modes[i] = '0';
			// }
			this.status               = this.device.status;
			this.state                = this.device.state;
			this.present              = this.device.present === true ? 'yes' : 'no';
			this.type                 = this.device.type;
			this.name                 = this.device.name;
			this.brand                = this.device.brand;
			this.model                = this.device.model;
			this.icon                 = this.device.icon;
			this.latitude             = this.device.latitude;
			this.longitude            = this.device.longitude;
			this.hostname             = this.device.hostname;
			this.port                 = this.device.port;
			this.serverurl            = this.device.serverurl;
			this.barrier_type         = this.device.barrier_type == null         ?  0 : this.device.barrier_type;
			this.prevent_customers    = this.device.prevent_customers == null    ?  false : this.device.prevent_customers;
			this.zone_id              = this.device.zone_id == null              ?  0 : this.device.zone_id;
			//TODO: GET RID OF THOSE OVERTIME AS THEY ARE DEPRECATED
			this.port_trigger_open    = this.device.port_trigger_open == null    ? '' : this.device.port_trigger_open.toString();
			this.port_trigger_close   = this.device.port_trigger_close == null   ? '' : this.device.port_trigger_close.toString();
			this.port_keep_open       = this.device.port_keep_open == null       ? '' : this.device.port_keep_open.toString();
			this.port_signal_open     = this.device.port_signal_open == null     ? '' : this.device.port_signal_open.toString();
			this.port_signal_close    = this.device.port_signal_close == null    ? '' : this.device.port_signal_close.toString();
			this.port_signal_blocked  = this.device.port_signal_blocked == null  ? '' : this.device.port_signal_blocked.toString();
			this.port_signal_presence = this.device.port_signal_presence == null ? '' : this.device.port_signal_presence.toString();
			//
			if (this.device.elka_settings != null) {
				var settings = JSON.parse(this.device.elka_settings.toString());
				//@ts-ignore
				if (typeof settings.stay_open_time != 'undefined') {
					this.elka_settings.stay_open_time = settings.stay_open_time;
				}
				//@ts-ignore
				if (typeof settings.prewarning_before_closing_time != 'undefined') {
					this.elka_settings.prewarning_before_closing_time = settings.prewarning_before_closing_time;
				}
				//@ts-ignore
				if (typeof settings.prewarning_before_opening_time != 'undefined') {
					this.elka_settings.prewarning_before_opening_time = settings.prewarning_before_opening_time;
				}
				//@ts-ignore
				if (typeof settings.maintenance_interval != 'undefined') {
					this.elka_settings.maintenance_interval = settings.maintenance_interval;
				}
				//@ts-ignore
				if (typeof settings.barrier_type != 'undefined') {
					this.elka_settings.barrier_type = settings.barrier_type;
				}
				//@ts-ignore
				if (typeof settings.barrier_speed != 'undefined') {
					this.elka_settings.barrier_speed = settings.barrier_speed;
				}
				//@ts-ignore
				if (typeof settings.radio_remote_control_code != 'undefined') {
					this.elka_settings.radio_remote_control_code = settings.radio_remote_control_code;
				}
				//@ts-ignore
				if (typeof settings.relay_operating_modes != 'undefined') {
					for(var i = 0; i < 14; i++) {
						//@ts-ignore
						this.elka_settings.relay_operating_modes[i] = settings.relay_operating_modes[i];
					}
				}
				//@ts-ignore
				if (typeof settings.loop_a_activated != 'undefined') {
					this.elka_settings.loop_a_activated = settings.loop_a_activated;
				}
				//@ts-ignore
				if (typeof settings.loop_a_sensitivity != 'undefined') {
					this.elka_settings.loop_a_sensitivity = settings.loop_a_sensitivity;
				}
				//@ts-ignore
				if (typeof settings.loop_a_holdtime != 'undefined') {
					this.elka_settings.loop_a_holdtime = settings.loop_a_holdtime;
				}
				//@ts-ignore
				if (typeof settings.loop_a_fnc_enter != 'undefined') {
					this.elka_settings.loop_a_fnc_enter = settings.loop_a_fnc_enter;
				}
				//@ts-ignore
				if (typeof settings.loop_a_fnc_exit != 'undefined') {
					this.elka_settings.loop_a_fnc_exit = settings.loop_a_fnc_exit;
				}
				//@ts-ignore
				if (typeof settings.loop_a_fnc_presence != 'undefined') {
					this.elka_settings.loop_a_fnc_presence = settings.loop_a_fnc_presence;
				}
				//@ts-ignore
				if (typeof settings.loop_b_activated != 'undefined') {
					this.elka_settings.loop_b_activated = settings.loop_b_activated;
				}
				//@ts-ignore
				if (typeof settings.loop_b_sensitivity != 'undefined') {
					this.elka_settings.loop_b_sensitivity = settings.loop_b_sensitivity;
				}
				//@ts-ignore
				if (typeof settings.loop_b_holdtime != 'undefined') {
					this.elka_settings.loop_b_holdtime = settings.loop_b_holdtime;
				}
				//@ts-ignore
				if (typeof settings.loop_b_fnc_enter != 'undefined') {
					this.elka_settings.loop_b_fnc_enter = settings.loop_b_fnc_enter;
				}
				//@ts-ignore
				if (typeof settings.loop_b_fnc_exit != 'undefined') {
					this.elka_settings.loop_b_fnc_exit = settings.loop_b_fnc_exit;
				}
				//@ts-ignore
				if (typeof settings.loop_b_fnc_presence != 'undefined') {
					this.elka_settings.loop_b_fnc_presence = settings.loop_b_fnc_presence;
				}
				//@ts-ignore
				if (typeof settings.loop_c_activated != 'undefined') {
					this.elka_settings.loop_c_activated = settings.loop_c_activated;
				}
				//@ts-ignore
				if (typeof settings.loop_c_sensitivity != 'undefined') {
					this.elka_settings.loop_c_sensitivity = settings.loop_c_sensitivity;
				}
				//@ts-ignore
				if (typeof settings.loop_c_holdtime != 'undefined') {
					this.elka_settings.loop_c_holdtime = settings.loop_c_holdtime;
				}
				//@ts-ignore
				if (typeof settings.loop_c_fnc_enter != 'undefined') {
					this.elka_settings.loop_c_fnc_enter = settings.loop_c_fnc_enter;
				}
				//@ts-ignore
				if (typeof settings.loop_c_fnc_exit != 'undefined') {
					this.elka_settings.loop_c_fnc_exit = settings.loop_c_fnc_exit;
				}
				//@ts-ignore
				if (typeof settings.loop_c_fnc_presence != 'undefined') {
					this.elka_settings.loop_c_fnc_presence = settings.loop_c_fnc_presence;
				}
				//@ts-ignore
				if (typeof settings.power_supply != 'undefined') {
					this.elka_settings.power_supply = settings.power_supply;
				}
				//@ts-ignore
				if (typeof settings.opening_limitation != 'undefined') {
					this.elka_settings.opening_limitation = settings.opening_limitation;
				}
				//@ts-ignore
				if (typeof settings.limitation_safety != 'undefined') {
					this.elka_settings.limitation_safety = settings.limitation_safety;
				}
				//@ts-ignore
				if (typeof settings.force_monitoring != 'undefined') {
					this.elka_settings.force_monitoring = settings.force_monitoring;
				}
				//@ts-ignore
				if (typeof settings.photoelectric_barrier_mode != 'undefined') {
					this.elka_settings.photoelectric_barrier_mode = settings.photoelectric_barrier_mode;
				}
				//@ts-ignore
				if (typeof settings.photoelectric_barrier_closing_auto != 'undefined') {
					this.elka_settings.photoelectric_barrier_closing_auto = settings.photoelectric_barrier_closing_auto;
				}
				//@ts-ignore
				if (typeof settings.ls_test != 'undefined') {
					this.elka_settings.ls_test = settings.ls_test;
				}
				//@ts-ignore
				if (typeof settings.induction_loop_safety_mode != 'undefined') {
					this.elka_settings.induction_loop_safety_mode = settings.induction_loop_safety_mode;
				}
				//@ts-ignore
				if (typeof settings.immediate_closing != 'undefined') {
					this.elka_settings.immediate_closing = settings.immediate_closing;
				}
				//@ts-ignore
				if (typeof settings.dead_mans_mode != 'undefined') {
					this.elka_settings.dead_mans_mode = settings.dead_mans_mode;
				}
				//@ts-ignore
				if (typeof settings.boom_missing_function != 'undefined') {
					this.elka_settings.boom_missing_function = settings.boom_missing_function;
				}
				//@ts-ignore
				if (typeof settings.auto_sync_function != 'undefined') {
					this.elka_settings.auto_sync_function = settings.auto_sync_function;
				}
				//@ts-ignore
				if (typeof settings.bt_combi_selection != 'undefined') {
					this.elka_settings.bt_combi_selection = settings.bt_combi_selection;
				}
				//@ts-ignore
				if (typeof settings.password_protection != 'undefined') {
					this.elka_settings.password_protection = settings.password_protection;
				}
				//@ts-ignore
				if (typeof settings.led_boom_lightning != 'undefined') {
					this.elka_settings.led_boom_lightning = settings.led_boom_lightning;
				}
				//@ts-ignore
				if (typeof settings.led_boom_lightning_red_yellow != 'undefined') {
					this.elka_settings.led_boom_lightning_red_yellow = settings.led_boom_lightning_red_yellow;
				}
				//@ts-ignore
				if (typeof settings.rtapl_end_pos_closed != 'undefined') {
					this.elka_settings.rtapl_end_pos_closed = settings.rtapl_end_pos_closed;
				}
				//@ts-ignore
				if (typeof settings.rtapl_before_opening != 'undefined') {
					this.elka_settings.rtapl_before_opening = settings.rtapl_before_opening;
				}
				//@ts-ignore
				if (typeof settings.rtapl_before_closing != 'undefined') {
					this.elka_settings.rtapl_before_closing = settings.rtapl_before_closing;
				}
				//@ts-ignore
				if (typeof settings.rtapl_during_opening != 'undefined') {
					this.elka_settings.rtapl_during_opening = settings.rtapl_during_opening;
				}
				//@ts-ignore
				if (typeof settings.rtapl_during_closing != 'undefined') {
					this.elka_settings.rtapl_during_closing = settings.rtapl_during_closing;
				}
				//@ts-ignore
				if (typeof settings.rtapl_during_intermediate_stop != 'undefined') {
					this.elka_settings.rtapl_during_intermediate_stop = settings.rtapl_during_intermediate_stop;
				}
				//@ts-ignore
				if (typeof settings.rtapl_end_pos_open != 'undefined') {
					this.elka_settings.rtapl_end_pos_open = settings.rtapl_end_pos_open;
				}
				//@ts-ignore
				if (typeof settings.gnapl_end_pos_closed != 'undefined') {
					this.elka_settings.gnapl_end_pos_closed = settings.gnapl_end_pos_closed;
				}
				//@ts-ignore
				if (typeof settings.gnapl_before_opening != 'undefined') {
					this.elka_settings.gnapl_before_opening = settings.gnapl_before_opening;
				}
				//@ts-ignore
				if (typeof settings.gnapl_before_closing != 'undefined') {
					this.elka_settings.gnapl_before_closing = settings.gnapl_before_closing;
				}
				//@ts-ignore
				if (typeof settings.gnapl_during_opening != 'undefined') {
					this.elka_settings.gnapl_during_opening = settings.gnapl_during_opening;
				}
				//@ts-ignore
				if (typeof settings.gnapl_during_closing != 'undefined') {
					this.elka_settings.gnapl_during_closing = settings.gnapl_during_closing;
				}
				//@ts-ignore
				if (typeof settings.gnapl_during_intermediate_stop != 'undefined') {
					this.elka_settings.gnapl_during_intermediate_stop = settings.gnapl_during_intermediate_stop;
				}
				//@ts-ignore
				if (typeof settings.gnapl_end_pos_open != 'undefined') {
					this.elka_settings.gnapl_end_pos_open = settings.gnapl_end_pos_open;
				}
				//@ts-ignore
				if (typeof settings.warning_end_pos_closed != 'undefined') {
					this.elka_settings.warning_end_pos_closed = settings.warning_end_pos_closed;
				}
				//@ts-ignore
				if (typeof settings.warning_before_opening != 'undefined') {
					this.elka_settings.warning_before_opening = settings.warning_before_opening;
				}
				//@ts-ignore
				if (typeof settings.warning_before_closing != 'undefined') {
					this.elka_settings.warning_before_closing = settings.warning_before_closing;
				}
				//@ts-ignore
				if (typeof settings.warning_during_opening != 'undefined') {
					this.elka_settings.warning_during_opening = settings.warning_during_opening;
				}
				//@ts-ignore
				if (typeof settings.warning_during_closing != 'undefined') {
					this.elka_settings.warning_during_closing = settings.warning_during_closing;
				}
				//@ts-ignore
				if (typeof settings.warning_during_intermediate_stop != 'undefined') {
					this.elka_settings.warning_during_intermediate_stop = settings.warning_during_intermediate_stop;
				}
				//@ts-ignore
				if (typeof settings.warning_end_pos_open != 'undefined') {
					this.elka_settings.warning_end_pos_open = settings.warning_end_pos_open;
				}
				//@ts-ignore
				if (typeof settings.dl1_input_selection != 'undefined') {
					this.elka_settings.dl1_input_selection = settings.dl1_input_selection;
				}
				//@ts-ignore
				if (typeof settings.dl1_fnc_passing_from_left != 'undefined') {
					this.elka_settings.dl1_fnc_passing_from_left = settings.dl1_fnc_passing_from_left;
				}
				//@ts-ignore
				if (typeof settings.dl1_fnc_passing_from_right != 'undefined') {
					this.elka_settings.dl1_fnc_passing_from_right = settings.dl1_fnc_passing_from_right;
				}
				//@ts-ignore
				if (typeof settings.dl1_vehicle_counting_type_from_left != 'undefined') {
					this.elka_settings.dl1_vehicle_counting_type_from_left = settings.dl1_vehicle_counting_type_from_left;
				}
				//@ts-ignore
				if (typeof settings.dl1_vehicle_counting_type_from_right != 'undefined') {
					this.elka_settings.dl1_vehicle_counting_type_from_right = settings.dl1_vehicle_counting_type_from_right;
				}
				//@ts-ignore
				if (typeof settings.dl1_fnc_entering_from_left != 'undefined') {
					this.elka_settings.dl1_fnc_entering_from_left = settings.dl1_fnc_entering_from_left;
				}
				//@ts-ignore
				if (typeof settings.dl1_fnc_entering_from_right != 'undefined') {
					this.elka_settings.dl1_fnc_entering_from_right = settings.dl1_fnc_entering_from_right;
				}
				//@ts-ignore
				if (typeof settings.dl1_fnc_report_entering_from_left != 'undefined') {
					this.elka_settings.dl1_fnc_report_entering_from_left = settings.dl1_fnc_report_entering_from_left;
				}
				//@ts-ignore
				if (typeof settings.dl1_fnc_report_entering_from_right != 'undefined') {
					this.elka_settings.dl1_fnc_report_entering_from_right = settings.dl1_fnc_report_entering_from_right;
				}
				//@ts-ignore
				if (typeof settings.dl2_input_selection != 'undefined') {
					this.elka_settings.dl2_input_selection = settings.dl2_input_selection;
				}
				//@ts-ignore
				if (typeof settings.dl2_fnc_passing_from_left != 'undefined') {
					this.elka_settings.dl2_fnc_passing_from_left = settings.dl2_fnc_passing_from_left;
				}
				//@ts-ignore
				if (typeof settings.dl2_fnc_passing_from_right != 'undefined') {
					this.elka_settings.dl2_fnc_passing_from_right = settings.dl2_fnc_passing_from_right;
				}
				//@ts-ignore
				if (typeof settings.dl2_vehicle_counting_type_from_left != 'undefined') {
					this.elka_settings.dl2_vehicle_counting_type_from_left = settings.dl2_vehicle_counting_type_from_left;
				}
				//@ts-ignore
				if (typeof settings.dl2_vehicle_counting_type_from_right != 'undefined') {
					this.elka_settings.dl2_vehicle_counting_type_from_right = settings.dl2_vehicle_counting_type_from_right;
				}
				//@ts-ignore
				if (typeof settings.dl2_fnc_entering_from_left != 'undefined') {
					this.elka_settings.dl2_fnc_entering_from_left = settings.dl2_fnc_entering_from_left;
				}
				//@ts-ignore
				if (typeof settings.dl2_fnc_entering_from_right != 'undefined') {
					this.elka_settings.dl2_fnc_entering_from_right = settings.dl2_fnc_entering_from_right;
				}
				//@ts-ignore
				if (typeof settings.dl2_fnc_report_entering_from_left != 'undefined') {
					this.elka_settings.dl2_fnc_report_entering_from_left = settings.dl2_fnc_report_entering_from_left;
				}
				//@ts-ignore
				if (typeof settings.dl2_fnc_report_entering_from_right != 'undefined') {
					this.elka_settings.dl2_fnc_report_entering_from_right = settings.dl2_fnc_report_entering_from_right;
				}
				//
			}
			//@ts-ignore
			this.$eventBus.on('device_state_changed', (data) => {
				if (this.device.id == data.device.id) {
					console.log('Device state changed!');
					console.log(data.device);
					this.state   = data.device.state;
					this.status  = data.device.status;
					this.present = data.device.present === true ? 'yes' : 'no';
				}
			});
		},
		watch: {
			'events_page': {
				handler: function(newValue) {
					// console.log('Current vaules:' + newValue.FirstName + ' ' + newValue.LastName);
					this.loadEvents();
				},
				deep: true
			}
		},
		methods: {
			capitalizeFirstLetter(text: string)
			{
				return text.charAt(0).toUpperCase() + text.slice(1);
			},
			selectTab(index: number)
			{
				this.selectedTab = index;
			},
			async loadZones()
			{
				const response = await ZoneService.getForFilters();
				if (response.count > 0)
				{
					this.all_zones = response.zones;
				}
			},
			async saveDeviceConfig()
			{
				const response = await DeviceService.editConfig(
					this.device.id,
					this.type,
					this.name,
					this.brand,
					this.model,
					this.hostname,
					this.port,
					this.serverurl,
					this.icon,
					this.zone_id,
					this.barrier_type,
					this.latitude,
					this.longitude,
					this.prevent_customers,
					JSON.stringify(this.elka_settings)
				);
				if(response.success)
				{
					//@ts-ignore
					this.$eventBus.emit('refresh_devices')
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('device_modified'),
						message: translate('saved_configuration_successfully'),
						duration: 2000
					})
					return toast.present();
				}
				else
				{
					var message = '';
					if (typeof response.error != 'undefined') {
						message = response.error;
					} else if(typeof response.errors != 'undefined' && typeof response.errors.message != 'undefined') {
						Object.keys(response.errors.message).forEach(key => {
							message += response.errors.message[key] + '.<br/>';
						});
					}
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('device_modification_error'),
						message: translate('error') + ': ' + message,
						duration: 2000
					})
					return toast.present();
				}
			},
			async openGate()
			{
				const response = await DeviceService.openGate(this.device.id);
				if(response.success)
				{
					//@ts-ignore
					this.$eventBus.emit('refresh_devices')
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('gate_opening'),
						message: translate('gate_successfully_opening'),
						duration: 2000
					})
					return toast.present();
				}
				else
				{
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('gate_error'),
						message: translate('cannot_open_gate'),
						duration: 2000
					})
					return toast.present();
				}
			},
			async closeGate()
			{
				const response = await DeviceService.closeGate(this.device.id);
				if(response.success)
				{
					//@ts-ignore
					this.$eventBus.emit('refresh_devices')
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('gate_closing'),
						message: translate('gate_successfully_closing'),
						duration: 2000
					})
					return toast.present();
				}
				else
				{
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('gate_error'),
						message: translate('cannot_close_gate'),
						duration: 2000
					})
					return toast.present();
				}
			},
			async triggerKeepGateOpen()
			{
				const response = await DeviceService.keepGateOpen(this.device.id, parseInt(this.keepOpenUntil));
				if(response.success)
				{
					//@ts-ignore
					this.$eventBus.emit('refresh_devices')
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('gate_opening'),
						message: translate('gate_successfully_opening'),
						duration: 2000
					})
					return toast.present();
				}
				else
				{
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('gate_error'),
						message: translate('cannot_open_gate'),
						duration: 2000
					})
					return toast.present();
				}
			},
			async lostTicket()
			{
				const response = await DeviceService.lostTicket(this.device.id);
				if(response.success)
				{
					//@ts-ignore
					this.$eventBus.emit('refresh_devices')
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('gate_opening'),
						message: translate('gate_successfully_opening'),
						duration: 2000
					})
					return toast.present();
				}
				else
				{
					const toast = await toastController
					.create({
						position: 'top',
						header: translate('gate_error'),
						message: translate('cannot_open_gate'),
						duration: 2000
					})
					return toast.present();
				}
			},
			async reboot()
			{
				const alert = await alertController
				.create({
					cssClass: 'my-custom-class',
					header: translate('reboot_device'),
					message: translate('are_you_sure_reboot_device', { name: this.device.name}),
					buttons: [
						{
							text: translate('cancel'),
							role: 'cancel',
							cssClass: 'secondary',
							id: 'cancel-button'
						},
						{
							text: translate('confirm'),
							id: 'confirm-button',
							handler: async () => {
								const response = await DeviceService.reboot(this.device.id);
								if(response.success)
								{
									//@ts-ignore
									this.$eventBus.emit('refresh_devices')
									const toast = await toastController
									.create({
										position: 'top',
										header: translate('gate_rebooting'),
										message: translate('gate_successfully_rebooting'),
										duration: 2000
									})
									return toast.present();
								}
								else
								{
									const toast = await toastController
									.create({
										position: 'top',
										header: translate('gate_error'),
										message: translate('cannot_reboot_gate'),
										duration: 2000
									})
									return toast.present();
								}
							}
						}
					]
				});
				return alert.present();
			},
			async restartservice()
			{
				const alert = await alertController
				.create({
					cssClass: 'my-custom-class',
					header: translate('restart_service'),
					message: translate('are_you_sure_restart_service', { name: this.device.name}),
					buttons: [
						{
							text: translate('cancel'),
							role: 'cancel',
							cssClass: 'secondary',
							id: 'cancel-button'
						},
						{
							text: translate('confirm'),
							id: 'confirm-button',
							handler: async () => {
								const response = await DeviceService.restartService(this.device.id);
								if(response.success)
								{
									//@ts-ignore
									this.$eventBus.emit('refresh_devices')
									const toast = await toastController
									.create({
										position: 'top',
										header: translate('service_restarting'),
										message: translate('service_successfully_restarting'),
										duration: 2000
									})
									return toast.present();
								}
								else
								{
									const toast = await toastController
									.create({
										position: 'top',
										header: translate('gate_error'),
										message: translate('cannot_restart_service'),
										duration: 2000
									})
									return toast.present();
								}
							}
						}
					]
				});
				return alert.present();
			},
			isMobile() {
				if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
					return true
				} else {
					return false
				}
			},
			async loadCamera(id) {
				//@ts-ignore
				const response = await CameraService.get(id);
				if (response && response.success) {
					const camera = response.camera;
					this.cameraMonitorId = camera.id;
					this.cameraSecret    = camera.secret;
					this.loadingCamera   = false;
					this.cameraUrl       = 'https://media.lexoh.com:52445/' + camera.monitorid + '/embed.html?realtime=true&autoplay=true&token=' + localStorage.getItem('token');
				}
			},
			async loadEvents() {
				//@ts-ignore
				const response = await EventService.list(this.events_page, '', [this.device.id]);
				if(response.success)
				{
					this.events_items = response.events;
					this.events_rows = response.count;
					this.events_loaded = true;
				}
				else
				{
					//something wrong... stop loading, show error with refresh button?
				}
			},
			formatDate(date: string)
			{
				//@ts-ignore
				return moment(date).utcOffset(Timezone.getTimezone(this.$store.state.auth.user)).format('YYYY-MM-DD HH:mm:ss');
			},
			translate_description(text: string)
			{
				text = text.replace('Gate has been opened by', translate('Gate has been opened by'));
				text = text.replace('in order to enter parking', translate('in order to enter parking'));
				text = text.replace('Gate has been opened in order to enter zone.', translate('Gate has been opened in order to enter zone.'));
				text = text.replace('Gate has been opened in order to exit zone.', translate('Gate has been opened in order to exit zone.'));
				text = text.replace('has logged in', translate('has_logged_in'));
				text = text.replace('Card scanned', translate('Card scanned'));
				text = text.replace('The card with number', translate('The card with number'));
				text = text.replace('has been scanned', translate('has been scanned'));
				text = text.replace('Coupon scanned', translate('Coupon scanned'));
				text = text.replace('The qr coupon with number', translate('The qr coupon with number'));
				text = text.replace('access card is not allowed to do entries', translate('access card is not allowed to do entries'));
				//printer
				text = text.replace('The printer device has connected.', translate('The printer device has connected.'));
				text = text.replace('The printer device has been disconnected.', translate('The printer device has been disconnected.'));
				text = text.replace('The printer device is online.', translate('The printer device is online.'));
				text = text.replace('The printer device is offline.', translate('The printer device is offline.'));
				text = text.replace('The printer device is waiting for online error recovery.', translate('The printer device is waiting for online error recovery.'));
				text = text.replace('The printer device has recovered.', translate('The printer device has recovered.'));
				text = text.replace('The printer device feed button has been pressed.', translate('The printer device feed button has been pressed.'));
				text = text.replace('The printer device feed button has been released.', translate('The printer device feed button has been released.'));
				text = text.replace('The printer plate has been opened.', translate('The printer plate has been opened.'));
				text = text.replace('The printer plate has been closed.', translate('The printer plate has been closed.'));
				text = text.replace('The printer device is feeding by button.', translate('The printer device is feeding by button.'));
				text = text.replace('The printer device is no longer feeding by button.', translate('The printer device is no longer feeding by button.'));
				text = text.replace('The printer device sensor for paper end stop is active.', translate('The printer device sensor for paper end stop is active.'));
				text = text.replace('The printer device sensor for paper end stop is inactive.', translate('The printer device sensor for paper end stop is inactive.'));
				text = text.replace('The printer device has occurred an error.', translate('The printer device has occurred an error.'));
				text = text.replace('The printer device has recovered from an error.', translate('The printer device has recovered from an error.'));
				text = text.replace('The printer device has occurred a mechanical error.', translate('The printer device has occurred a mechanical error.'));
				text = text.replace('The printer device has recovered from a mechanical error.', translate('The printer device has recovered from a mechanical error.'));
				text = text.replace('The printer device has occurred an auto cutter error.', translate('The printer device has occurred an auto cutter error.'));
				text = text.replace('The printer device has recovered from an auto cutter error.', translate('The printer device has recovered from an auto cutter error.'));
				text = text.replace('The printer device has occurred an unrecoverable error.', translate('The printer device has occurred an unrecoverable error.'));
				text = text.replace('The printer device has recovered from an unrecoverable error.', translate('The printer device has recovered from an unrecoverable error.'));
				text = text.replace('The printer device has occurred an auto recoverable error.', translate('The printer device has occurred an auto recoverable error.'));
				text = text.replace('The printer device has recovered from an auto recoverable error.', translate('The printer device has recovered from an auto recoverable error.'));
				text = text.replace('The printer device has detected adequate paper.', translate('The printer device has detected adequate paper.'));
				text = text.replace('The printer device has detected inadequate paper.', translate('The printer device has detected inadequate paper.'));
				text = text.replace('The printer device has detected paper near end.', translate('The printer device has detected paper near end.'));
				text = text.replace('The printer device has undetected paper near end.', translate('The printer device has undetected paper near end.'));
				text = text.replace('The printer device has detected paper.', translate('The printer device has detected paper.'));
				text = text.replace('The printer device has detected missing paper.', translate('The printer device has detected missing paper.'));
				text = text.replace('The printer device has detected paper roll end.', translate('The printer device has detected paper roll end.'));
				text = text.replace('The printer device has undetected paper roll end.', translate('The printer device has undetected paper roll end.'));
				//customer account
				text = text.replace('has created the customer account', translate('has_created_the_customer_account'));
				text = text.replace('has modified the customer account', translate('has_modified_the_customer_account'));
				text = text.replace('has deleted the customer account', translate('has_deleted_the_customer_account'));
				//access card
				text = text.replace('has created the access card', translate('has_created_the_access_card'));
				text = text.replace('has modified the access card', translate('has_modified_the_access_card'));
				text = text.replace('has deleted the access card', translate('has_deleted_the_access_card'));
				//Validation
				text = text.replace('MaxEntrancesReached', translate('MaxEntrancesReached'));
				text = text.replace('has already reached max entrances', translate('has already reached max entrances'));
				text = text.replace('DoesNotExists', translate('DoesNotExists'));
				text = text.replace('unable to find access card', translate('unable to find access card'));
				text = text.replace('access card limit has already been reached - Access card', translate('MaxEntrancesReached') + ' - ' + translate('access_card') + '#');
				//user account
				text = text.replace('has created the user account', translate('has_created_the_user_account'));
				text = text.replace('has modified the user account', translate('has_modified_the_user_account'));
				text = text.replace('has deleted the user account', translate('has_deleted_the_user_account'));
				//config
				text = text.replace('has modified the config', translate('has_modified_the_config'));
				text = text.replace('` from `', '` ' + translate('from') + ' `');
				text = text.replace('` to `', '` ' + translate('to') + ' `');
				//
				text = text.replace('has connected', translate('has_connected'));
				text = text.replace('has disconnected', translate('has_disconnected'));
				//
				text = text.replace('User `', translate('user') + ' `');
				text = text.replace('Customer `', translate('customer') + ' `');
				text = text.replace('Device `', translate('device') + ' `');
				text = text.replace('Guest has entered the parking.', translate('guest_entered_parking'));
				//signals
				text = text.replace('has manually sent stay open signal to the device', translate('has_sent_stay_open_signal'));
				text = text.replace('has manually sent close signal to the device', translate('has_sent_close_signal'));
				text = text.replace('has manually sent open signal to the device', translate('has_sent_open_signal'));
				text = text.replace('for a duration of', translate('for_a_duration_of'));
				text = text.replace('`indefinitely`', translate('_indefinitely_'));
				text = text.replace('received gate signal', translate('received_gate_signal'));
				text = text.replace('State has changed to', translate('state_changed_to'));
				text = text.replace('closed', translate('closed'));
				text = text.replace('opened', translate('opened'));
				text = text.replace('closing', translate('closing'));
				text = text.replace('opening', translate('opening'));
				text = text.replace('blocked', translate('blocked'));
				text = text.replace('max vehicules inside limit reached', translate('max vehicules inside limit reached'));
				//zones
				text = text.replace('has created the zone', translate('has_created_zone'));
				text = text.replace('has modified the zone', translate('has_modified_zone'));
				text = text.replace('has deleted the zone', translate('has_deleted_zone'));

				text = text.replace('Open', translate('open'));
				text = text.replace('Closed', translate('closed'));
				text = text.replace('Blocked', translate('blocked'));

				text = text.replace('a customer', translate('a customer'));
				text = text.replace('a guest', translate('a guest'));
				text = text.replace('a user', translate('a user'));

				text = text.replace('customer', translate('customer'));
				text = text.replace('guest', translate('guest'));
				text = text.replace('user', translate('user'));
				text = text.replace('Access card', translate('access_card'));
				text = text.replace('does not exists', translate('DoesNotExists'));
				return text;
			}
		},
		computed: {
			darkMode() {
				return document.body.classList.contains('dark');
			},
			can_control_devices()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_control_devices');
			},
			can_edit_devices()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_edit_devices');
			},
			can_view_cameras()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_cameras');
			},
			can_view_events()
			{
				//@ts-ignore
				return this.$root.hasPermission('can_view_events');
			},
		}
	});
